export default __webpack_public_path__ + "static/media/giraffe2.a6ca7f76.png";